/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum NotificationState {
    NEW = 'NEW',
    READ = 'READ',
    DELETED = 'DELETED'
}


export function NotificationStateFromJSON(json: any): NotificationState {
    return NotificationStateFromJSONTyped(json, false);
}

export function NotificationStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationState {
    return json as NotificationState;
}

export function NotificationStateToJSON(value?: NotificationState | null): any {
    return value as any;
}

